import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const isDemoMode = !firebaseConfig.apiKey || firebaseConfig.apiKey.trim() === '';

let app: any;
let auth: ReturnType<typeof getAuth> | null = null;
let db: ReturnType<typeof getFirestore> | null = null;
let storage: ReturnType<typeof getStorage> | null = null;
let functions: ReturnType<typeof getFunctions> | null = null;

if (!isDemoMode) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  functions = getFunctions(app, 'us-central1');
} else {
  console.warn('Running in demo mode (Firebase not configured)');
}

export { auth as firebaseAuth, db, storage, functions };

// Expose debug helpers on window for admin console use
if (!isDemoMode && db) {
  (window as any).__db = db;
  (window as any).__hardDeleteBySlug = async (slug: string) => {
    const { collection, query, where, getDocs, deleteDoc, doc } = await import('firebase/firestore');
    const q = query(collection(db!, 'articles'), where('slug', '==', slug));
    const snap = await getDocs(q);
    if (snap.empty) { console.log('No doc with slug', slug); return; }
    for (const d of snap.docs) {
      console.log('Deleting:', d.id, d.data().title, 'deletedAt:', d.data().deletedAt);
      await deleteDoc(doc(db!, 'articles', d.id));
      console.log('Deleted', d.id);
    }
    console.log('Done — refresh the page');
  };
  (window as any).__inspectBySlug = async (slug: string) => {
    const { collection, query, where, getDocs } = await import('firebase/firestore');
    const q = query(collection(db!, 'articles'), where('slug', '==', slug));
    const snap = await getDocs(q);
    if (snap.empty) { console.log('No doc with slug', slug); return; }
    for (const d of snap.docs) {
      console.log('Doc ID:', d.id);
      console.log('Data:', JSON.parse(JSON.stringify(d.data())));
    }
  };
}
